// import { getDocumentsByIdsArray } from '@/shared/actions/erp';
import { ImageModal } from '@/shared/components/ui/Images';
import {
  IDataPreventa,
  IDataProspecto,
  OrdenTrabajo,
  UrlFotosEntradaType,
  UrlFotosSalidaType,
} from '@/shared/interfaces';
import { normalizeSalidaPhotoName } from './fotos-salida.utils';
// import {
//   // getDocumentArrByUrlArrDrive,
//   getUrlFromImage,
// } from '../upload-many-images.utils';

export const calcPreventaImages = async (
  preventa?: IDataPreventa,
  prospecto?: IDataProspecto
): Promise<ImageModal[]> => {
  if (!preventa) return [];

  const imageUrlArray = [
    preventa?.url_foto_identificacion_delantera || "",
    preventa?.url_foto_identificacion_posterior || "",
    preventa?.url_foto_aceptacion || "",
    preventa?.url_foto_cuenta_bancaria || "",
    preventa?.url_foto_tarjeta || "",
    prospecto?.url_foto_bono_desarrollo_humano || "",
    prospecto?.url_foto_documento_legal_representante || "",
    prospecto?.url_foto_tutor_discapacidad || "",
  ]//.filter(Boolean) as string[];

  const imagesWithData = [
    {
      title: "Identificación Delantera",
      urlImG: imageUrlArray[0],
    },
    {
      title: "Identificación Posterior",
      urlImG: imageUrlArray[1],
    },
    ...(imageUrlArray[2] ? [{
      title: "Aceptación",
      urlImG: imageUrlArray[2],
    }] : []),
    {
      title: "Cuenta Bancaria",
      urlImG: imageUrlArray[3],
    },
    {
      title: "Tarjeta",
      urlImG: imageUrlArray[4],
    },

    {
      title: "Bono desarrollo humano",
      urlImG: imageUrlArray[5],
    },

    {
      title: "Representante legal",
      urlImG: imageUrlArray[6],
    },

    {
      title: "Tutor discapacidad",
      urlImG: imageUrlArray[7],
    },
  ]
  // const imagesWithData = await getDocumentArrByUrlArrDrive(imageUrlArray);

  return imagesWithData.map((image, index) => ({
    img: image.urlImG,
    title: image.title,
    id: `${index}`,
  }));
};

export const calcOTImages = (
  ordenTrabajo: OrdenTrabajo,
  setImagesRequired:
    | 'urls_fotos_entrada'
    | 'urls_fotos_salida' = 'urls_fotos_entrada'
): ImageModal[] => {
  const imageUrlObj = ordenTrabajo[setImagesRequired] || null;
  if (!imageUrlObj) return [];

  if (imageUrlObj.hasOwnProperty('photosEntrada')) {
    const photosEntradaObjtype: UrlFotosEntradaType =
      imageUrlObj as UrlFotosEntradaType;

    const { photosEntrada } = photosEntradaObjtype || {};

    const { ...restPhotosEntrada } = photosEntrada || {}

    const auxPhotosEntrada = Object.values(restPhotosEntrada || {})
      .map(image => ({
        img: image?.photoUrl!,
        title: image?.photoName!,
        id: image?.photoId!,
      }))
      .filter(Boolean)
    

    return [
      ...auxPhotosEntrada,
    ];
  }

  if (imageUrlObj.hasOwnProperty('photosSalida')) {
    const photosSalidaObjtype: UrlFotosSalidaType =
      imageUrlObj as UrlFotosSalidaType;

    const { photosSalida } = photosSalidaObjtype || {};
    const { fotosAdicionales, ...restPhotosSalida } = photosSalida || {}
    
    const auxPhotosSalida = Object.values(restPhotosSalida || {})
      .map(image => ({
        img: image?.photoUrl!,
        title: normalizeSalidaPhotoName(image?.photoName),
        id: image?.photoId!,
      }))
      .filter(Boolean)

    const { fotoPuntosRedInstalados, fotoPuntosRedNoInstalados, fotoRoutersAdicionalesInstalados } = fotosAdicionales || {}
    
    const auxFotosPuntosRedInstalados = Object.values(fotoPuntosRedInstalados || {})
      .map(image => ({
        img: image?.photoUrl!,
        title: image?.photoName!,
        id: image?.photoId!,
      }))
      .filter(Boolean)
    
    const auxFotosPuntosRedNoInstalados = Object.values(fotoPuntosRedNoInstalados || {})
      .map(image => ({
        img: image?.photoUrl!,
        title: image?.photoName!,
        id: image?.photoId!,
      }))
      .filter(Boolean)
    
    const auxFotosRoutersAdicionalesInstalados = Object.values(fotoRoutersAdicionalesInstalados || {})
      .map(image => ({
        img: image?.photoUrl!,
        title: image?.photoName!,
        id: image?.photoId!,
      }))
      .filter(Boolean)
    
    return [
      ...auxPhotosSalida, 
      ...auxFotosPuntosRedInstalados,
      ...auxFotosPuntosRedNoInstalados, 
      ...auxFotosRoutersAdicionalesInstalados
    ];
  }

  return [];
};

//deprecated
// export const calcOTImagesFetch = async (
//   ordenTrabajo: OrdenTrabajo,
//   setImagesRequired:
//     | 'urls_fotos_entrada'
//     | 'urls_fotos_salida' = 'urls_fotos_entrada'
// ): Promise<ImageModal[]> => {
//   const imageUrlObj = ordenTrabajo[setImagesRequired] || null;
//   if (!imageUrlObj) return [];

//   let photosEntradaArrayIds: (string|null)[] = [];
//   if (imageUrlObj.hasOwnProperty('photosEntrada')) {
//     const photosEntrada: UrlFotosEntradaType =
//       imageUrlObj as UrlFotosEntradaType;

//     photosEntradaArrayIds = photosEntrada?.id_images_entrada || [];
//   }

//   const res = await getDocumentsByIdsArray((photosEntradaArrayIds?.filter(id => id !== null) as string[]) || []);

//   return res?.data?.map(image => ({
//     img: getUrlFromImage(image),
//     title: image?.nombre,
//     id: image?.id_archivos,
//   }));
// };
